const getType = (item) => {
	if (item.module === 'sonos') return 'speaker';
	if (item.module === 'unifi') return 'mobile';
	if (['hue', 'zigbee'].includes(item.module)) {
		if (item.data && item.data.type === 'ZLLTemperature') return 'temperature';
		if (item.data && item.data.type === 'ZHATemperature') return 'temperature';
		if (item.data && item.data.type === 'ZLLLightLevel') return 'lightLevel';
		if (item.data && item.data.type === 'ZLLPresence') return 'presence';
		if (item.data && item.data.type === 'ZHAHumidity') return 'humidity';
		if (item.data && item.data.type === 'ZHAPressure') return 'pressure';
		if (item.data && item.data.type === 'ZHAConsumption') return 'consumption';
		if (item.data && item.data.type === 'ZHAPower') return 'power';
		if (item.data && item.data.type === 'ZHAOpenClose') return 'door';
		return 'light';
	}
	return 'unknown';
};

export default getType;
